import React from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import propTypes from 'prop-types'
import {find, get, has, isNil} from 'lodash'
import NumberString from 'containers/numberString'
import {iconNames} from 'components/icon'
import TreeSearcher, {TreeListType} from 'components/treeSearcher'
import {urls} from 'helpers/url'

const ContactListSearcher = (props) => {
  const {lists, categories, multiSelect, value, onSelect, onAddContactList} = props

  const headerAction = has(props, 'headerAction') ? props.headerAction : null

  const placeHolderData = {
    messageTitle: 'Looks like there are no contact lists',
    messageIcon: iconNames.contactListGroupFilled,
    iconSize: 36,
    actions: [
      {
        title: 'Add Contact List',
        className: 'add-contact-list',
        primary: false,
        onClick: onAddContactList,
      },
    ],
  }

  return (
    <TreeSearcher
      parentLabel="All Contact Lists"
      options={lists}
      folders={categories}
      multiSelect={multiSelect}
      value={value}
      listType={TreeListType.FLAT}
      rootId={-1}
      onChange={
        (id, toggled) => {
          const list = find(lists, ['id', id])
          onSelect({
            id: list.id,
            name: list.label,
            title: get(list, 'title', null),
            categoryId: list.parentId,
          }, toggled)
        }
      }
      optionIcon={iconNames.contactListGroupFilled}
      headerAction={headerAction}
      placeHolderData={placeHolderData}
    />
  )
}

ContactListSearcher.propTypes = {
  headerAction: propTypes.any,
  lists: propTypes.array,
  categories: propTypes.array,
  multiSelect: propTypes.bool,
  value: propTypes.arrayOf(propTypes.number),
  onSelect: propTypes.func,
  onAddContactList: propTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
  const contactListCategories = get(state, 'data.contactListCategories', []) || []
  const ownPropsContactLists = get(ownProps, 'contactLists', [])
  const contactLists = ownPropsContactLists.concat(get(state, 'data.contactLists', []) || [])
  const categories = contactListCategories.map(category => ({
    id: category.id,
    label: category.name,
    parentId: isNil(category.parentId)
      ? -1
      : category.parentId,
  }))

  const lists = contactLists.map(list => ({
    id: list.id,
    label: list.summary && list.summary.value
      ? <div>{list.name} (<NumberString>{list.summary.value}</NumberString>)</div>
      : list.name,
    title: list.name,
    parentId: isNil(list.categoryId)
      ? -1
      : list.categoryId,
  }))

  return {
    categories,
    lists,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onAddContactList: () => dispatch(push(urls.contacts.contactListBuilderUrl)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactListSearcher)
